import React, { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useApplicationsQuery } from 'core/api/applications';
import { useDateRangeStore } from 'stores/dateRange';
import { isDateInDateRange } from 'utils/dateTimeFormat';
import BarDiagram from './BarDiagram';
import { SCardWithTitleResponsive } from './styles';

const ApplicationDiagram: FC = () => {
    const { t } = useTranslation();
    const { data: applicationsData } = useApplicationsQuery();
    const applications = useMemo(() => applicationsData ?? [], [applicationsData]);
    const dateRangeSelected = useDateRangeStore((s) => s.dateRange);
    const [value, setValue] = useState<number>(0);

    useEffect(() => {
        const engagedApplications = applications.filter(
            (app) => app.engagmentDate && isDateInDateRange(new Date(app.engagmentDate), dateRangeSelected),
        );
        setValue(engagedApplications.length);
    }, [applications, dateRangeSelected]);

    return (
        <SCardWithTitleResponsive label={t('dashboard.engaged-application-number', { count: value })}>
            <BarDiagram value={value} />
        </SCardWithTitleResponsive>
    );
};

export default ApplicationDiagram;
